document.addEventListener('turbolinks:load', () => {
    $('.message .close')
        .on('click', function () {
            $('.flashMessage').remove()
        })
});
